export const achRejectFiltersInitialValues = {
	mid: "",
	merchantName: "",
	dateOfRejectFrom: "",
	dateOfRejectTo: "",
	returnCode: "",
	agentOffice: "",
	sourceOfData: "",
	rejectStatus: "",
	processor: "",
	dateDownloadedFrom: "",
	dateDownloadedTo: "",
	primaryAgent: "",
	transactionType: "",
	recoveredFrom: "",
	dateRecoveredFrom: "",
	dateRecoveredTo: "",
	accountOnHold: "",
	merchantStatus: "",
	terminationLetter: "",
	dateUpdatedFrom: "",
	dateUpdatedTo: "",
	lastUpdatedBy: "",
	dateIngestedFrom: "",
	dateIngestedTo: "",
};
